// kokeile tätä
// https://medium.com/@networkaaron/swiper-how-to-destroy-swiper-on-min-width-breakpoints-a947491ddec8

// breakpoint where swiper will be destroyed
// and switches to a dual-column layout
const breakpoint = window.matchMedia( '(min-width:720px)' );
// keep track of swiper instances to destroy later
let featuredSwiper;

const breakpointChecker = function() {
   // if larger viewport and multi-row layout needed
   if ( breakpoint.matches === true ) {

      // clean up old instances and inline styles when available
      if ( featuredSwiper !== undefined ) {

        if (Array.isArray(featuredSwiper)) {
          featuredSwiper.forEach(function(el) {
            el.destroy( true, true );
          })
        } else {
          featuredSwiper.destroy(true, true);
        }

      }
      // or/and do nothing
      return;
   // else if a small viewport and single column layout needed
   } else if ( breakpoint.matches === false ) {
      // fire small viewport version of swiper
      return enableSwiper();
   }
};

const enableSwiper = function() {
  featuredSwiper = new Swiper ('.featured-swiper', {
    slidesPerView: 'auto',
    centeredSlides: false,
    loop: false,
    spaceBetween: 0,
    navigation: false,
    scrollbar: {
      el: '.featured-swiper-scrollbar',
      draggable: true,
    },
    mousewheel: false,
});
};

// keep an eye on viewport size changes
window.addEventListener('resize', function(){
  breakpointChecker();
});

// kickstart
breakpointChecker();

// /* Swiper
// **************************************************************/
// var featuredSwiper = new Swiper('.featured-swiper', {});
// var init = false;

// var featuredSwiper = document.querySelector('.swiper').swiper;

// /* Which media query
// **************************************************************/
// function swiperMode() {
//     let mobile = window.matchMedia('(min-width: 0px) and (max-width: 719px)');
//     let tablet = window.matchMedia('(min-width: 720px)');

//     // Enable (for mobile)
//     if(mobile.matches) {
//         if (!init) {
//             init = true;
//             featuredSwiper = new Swiper('.featured-swiper', {
//                 slidesPerView: "auto",
//                 centeredSlides: false,
//                 loop: false,
//                 spaceBetween: 0,
//                 navigation: false,
//                 scrollbar: {
//                   el: '.featured-swiper-scrollbar',
//                   draggable: true,
//                 },
//                 mousewheel: false,
//                 breakpoints: {
//                 }

//             });
//         }

//     }

//     // Disable (for tablet)
//     else if(tablet.matches) {
//         featuredSwiper.destroy( true, true);
//         init = false;
//     }
// }

// /* On Load
// **************************************************************/
// window.addEventListener('load', function() {
//     swiperMode();
// });

// /* On Resize
// **************************************************************/
// window.addEventListener('resize', function() {
//     swiperMode();
// });
